<lms-breadcrumb [label]="'students.invite.title'"></lms-breadcrumb>
<div class="row margin-top">
  <div class="col s12">
    <lms-dynamic-form
      *ngIf="!client; else showInviteForm"
      [title]="'students.invite.title'"
      [questions]="clientQuestions"
      [options]="{ submitLabel: 'wizard.nextButton' }"
      (submit)="selectClient($event)"
      #clientForm
    >
      <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="goBack()" form-actions-before>
      </gl-button>
    </lms-dynamic-form>
    <ng-template #showInviteForm>
      <lms-dynamic-form
        [options]="{ submitLabel: 'actions.saveChanges' }"
        [title]="'students.invite.title'"
        [action]="'students.invite'"
        [questions]="questions"
        (submit)="updateSelfRegistrationConfig($event)"
        #selfRegistrationForm
      >
      </lms-dynamic-form>
    </ng-template>
  </div>
</div>
